<div class="align-items-center flex justify-content-center lg:px-8 md:px-6 px-4 py-8">
    <div class="surface-card p-4 shadow-2 border-round w-full lg:w-6">
        <div class="text-center mb-5">
            <img src="assets/imagens/lxtech-logo.png" alt="Image" height="100" class="mb-3">
        </div>
        
        <div>
            <form [formGroup]="loginForm">
                Olá, usuario!
                <br />
                Digite sua nova senha:
                <br /><br />
                <label for="password" class="block text-900 mb-2">Senha</label>
                <input id="password" type="password" placeholder="Senha" pInputText class="w-full mb-3 form-control" formControlName="password">

                <label for="confirmPassword" class="block text-900 mb-2">Digite novamente a senha:</label>
                <input id="confirmPassword" type="password" placeholder="Confirme a senha" pInputText class="w-full mb-3 form-control" formControlName="confirmPassword">
        
                <button pButton pRipple label="Redefinir" icon="pi pi-key" class="w-full" (click)="submit()"></button>
            </form>
        </div>
    </div>
</div>